import React from 'react';

const TaskCounts = ({ taskCounts }) => {
    const statusColors = {
        not_started: 'text-muted',
        in_progress: 'text-info',
        completed: 'text-success',
        on_hold: 'text-primary',
        canceled: 'text-danger',
        awaiting_feedback: 'text-warning',
        testing: 'text-success',
        total: 'text-warning',
    };

    return (
        <>
            <div className="row">
                {taskCounts && taskCounts.length > 0 && taskCounts.map((taskCount) => (
                    <div key={taskCount.status} className="col-md-3 col-sm-4 col-6 mb-1">
                        <div className="card border shadow-sm p-3 text-center">
                            <h3 className={statusColors[taskCount.status]}>
                                <span className="text-secondary">{taskCount.count}</span> {taskCount.status.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())}
                            </h3>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default TaskCounts;
